import Yucatan  from "../yucatan";
import { SVGMap } from 'react-svg-map';
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import BtnLetters from "./BtnLetters";
// import { logoyuc } from './../assets/logo-congreso.png';


function Mapa() {
  
  const navigate = useNavigate();
  const [tooltipStyle, setTooltipStyle] = useState({
     display: 'none' 
  })
  const [pointedLocation, setPointedLocation] = useState(null)


  const onClick = (id) => {
    navigate(process.env.PUBLIC_URL+'/'+id);
  }

  const onHover = (name) => {
    
    setPointedLocation(
      (
        <div>
          <h4 className="mb-0">{name}</h4>
          {/* <p>Obras: </p> */}
        </div>
      )
    );
  }

  const onMouseMove = (event) => {
    const tooltipStyle = {
			display: 'block',
			top: event.clientY + 10,
			left: event.clientX - 100
		};
    setTooltipStyle( tooltipStyle );
  }

  const onMouseOut = () => {
    setPointedLocation(null);
    setTooltipStyle({ display: 'none' });
	}

  
  return (
    <>
      <div className="d-flex justify-content-center align-items-center mt-5">
        <div className="row">
          <div className="col-sm-12 col-md-5 p-1 selecciona">
            <img src={require('../assets/selecciona.png')} 
                 className="img-fluid mb-5" 
                 alt="Selecciona un sujeto obligado" 
            />
            <div className="logos">
              <div className="card card-img border-0 mb-5">
                <div className="card-body p-0">
                  <h5 className="card-title">
                    <img src={require('../assets/ejecutivo-title.png')} 
                         className="img-fluid" 
                         alt="Poder Ejecutivo del Estado" 
                    />
                  </h5>
                  <Link to={`${process.env.PUBLIC_URL}/poder-ejecutivo-del-estado`}>
                    <img id="img-gobierno" 
                         src={require('../assets/logo-yucatan.png')} 
                         alt="Poder Ejecutivo del Estado de Yucatán" 
                    />
                  </Link>
                  <p className="mb-0 mt-2 text-end">
                    <Link 
                      to={`${process.env.PUBLIC_URL}/poder-ejecutivo-del-estado`} className="btn btn-info text-white">
                        Ingresar
                    </Link>
                    </p>
                </div>
              </div>
              <div id="divspace" className="d-none"></div>
              <div className="card card-img border-0 mb-5">
                <div className="card-body p-0">
                  <h5 className="card-title">
                    <img src={require('../assets/congreso-title.png')} 
                        className="img-fluid" alt="H Congreso del Estado de Yucatán" 
                    />
                  </h5>
                  <Link to={`${process.env.PUBLIC_URL}/h-congreso-del-estado`}>
                    <img id="img-congreso" 
                         src={require('../assets/logo-congreso.png')} 
                         alt="Poder Ejecutivo del Estado de Yucatán" 
                    />
                  </Link>
                  <p className="mb-0 mt-2 text-end">
                    <Link to={`${process.env.PUBLIC_URL}/h-congreso-del-estado`} className="btn btn-info text-white">Ingresar</Link>
                  </p>
                </div>
              </div>
            </div> 
          </div>
          <div className="col-sm-12 col-md-7 mapa-interactivo">
            <div className="row text-end">
              <div className="col-8 p-1">
                <img id="mpios-title" src={require('../assets/municipios-mapa-interactivo-1.png')} className="img-fluid mb-5" alt="municipios mapa interactivo" />
              </div>
              <div id="porcentaje" className="col-4 p-1 text-start">
                <Link to={`${process.env.PUBLIC_URL}/porcentaje-minimo-de-participacion-ciudadana`}>
                  <img id="mpios-title" src={require('../assets/porcentajes.png')} className="img-fluid mb-5 porcentaje" alt="municipios mapa interactivo" style={{ height: "57px", zIndex:2 }} />
                </Link>
              </div>
            </div>
            <SVGMap
              id='mapa'
              className="mapa" 
              locationClassName="location"
              onLocationClick={ (e) => onClick(e.target.id) }
              onLocationMouseOver= { (e) => onHover(e.target.attributes.name.value) }
              onLocationMouseMove={onMouseMove}
              onLocationMouseOut={onMouseOut}
              map={Yucatan}
            />
            <div className="map_tooltip" style={tooltipStyle}>
                {pointedLocation}
            </div>
          </div>
        </div>
        
      </div>
      <BtnLetters />
    </>
  );
}

export default Mapa;
